import {GameIconWrapperDefaultBox} from './game-icon-wrapper.default.box';

export const GameIconWrapperBox = GameIconWrapperDefaultBox;